export default [
  {
    path: "/login",
    name: "Login",
    component: () => import("@/views/Page/Auth/login.vue"),
    meta: {
      title: "Login",
      requiresAuth: false,
      // Local login must NEVER auto-redirect to SSO.
      skipSsoAutoRedirect: true,
    },
  },
  {
    path: "/forgot-password",
    name: "ForgotPassword",
    component: () => import("@/views/Page/Auth/ForgotPassword.vue"),
    meta: {
      requiresAuth: false,
      skipSsoAutoRedirect: true,
    },
  },
  {
    path: "/auth/stats/callback",
    name: "StatsSsoCallback",
    component: () => import("@/views/Page/Auth/StatsSsoCallback.vue"),
    meta: {
      title: "SSO Callback",
      requiresAuth: false,
      skipSsoAutoRedirect: true,
    },
  },
];
